<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Edit Discipleship Group
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label">Select Discipleship Group</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="selectGroupId"
        placeholder="Select group..."
        @change="fetchCurrentParticipants(selectGroupId)"
      >
        <el-option
          v-for="item in groupsSelect"
          :key="item.group_id"
          :label="item.leader"
          :value="item.group_id"
        />
      </el-select>
    </el-row>
    <br>
    <div v-if="selectGroupId" class="row-col-md-4">
      <label class="col-md-4 col-form-label">Edit Leader</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="newLeaderPersonId"
        placeholder="Select leader..."
      >
        <el-option
          v-for="item in leaders"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <br>
    <div style="margin-top: 20px;" v-if="selectGroupId">
      <h4 class="card-title center">
        Edit Participants
      </h4>
      <el-autocomplete
        v-model="editParticipant"
        :fetch-suggestions="queryAddableParticipants"
        value-key="name"
        @select="handleSelectParticipant"
        id="searchAutocomplete-editgroup"
        style="width: 100%;"
      />
      <table class="table table-hover" v-show="selectedParticipants">
        <tbody>
          <tr
            v-for="participant in selectedParticipants"
            :key="participant.id"
          >
            <td style="width: 100%;">
              {{ participant.name }}
              <el-button
                @click="handleRemoveFromSelected(participant)"
                class="small"
              >
                <i class="el-icon-close" />
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- For now, growing/commissioned cannot be set for disciples added to groups.
          They will all be marked as growing automatically -->

    <!-- <p>Is this person a Growing Disciple or a Commissioned Disciple?</p>
    <div class="text-center">
      <el-radio v-model="newDiscipleType" label="Growing Disciple" />
      <el-radio v-model="newDiscipleType" label="Commissioned Disciple" />
    </div>
    <br>
    <span
      v-if="isOneOfTheseRoles(['missionary', 'affiliate', 'chaplain', 'td', 'parish-missionary', 'parish-td'])"
    > -->
    <!-- <p
      class="
      col-md-12"
    >
      *If your new disciple isn't on this list, please add them into the People tab.
    </p> -->
    <!-- <br>
      <el-row>
        <el-checkbox class="col-md-1" v-model="isDiscipler" @change="handleCheck" />
        <label class="col-form-label">I will be leading this person in discipleship.</label>
      </el-row>
      <el-row v-if="!isDiscipler">
        <label class="col-md-4 col-form-label">New Discipler</label>
        <el-select
          class="col-md-8 select-default"
          filterable
          clearable
          v-model="newDisciplerPersonId"
          placeholder="Type new discipler..."
        >
          <el-option
            v-for="item in addableDisciplers"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
    </span> -->

    <p>
      <span v-if="validationError.disciple === true" style="color: red;">
        Please select a group.<br>
      </span>
      <!-- <span v-if="validationError.type === true" style="color: red;">
        Please select whether this person is a growing or commissioned disciple.
      </span> -->
    </p>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Save
      </p-button>
      <p-button type="danger" v-if="saving">
        Updating...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DiscipleshipGroupsRepository = RepositoryFactory.get('discipleshipGroups');

function validateDisciple(selectGroupId) {
    return !!selectGroupId;
}

// function validateType(newDiscipleType) {
//     return !!newDiscipleType;
// }

export default {
    name: 'EditDiscipleshipGroupModal',
    components: {
        Modal
    },
    data() {
        return {
            leaders: [],
            groupsSelect: [],
            showModal: false,
            validationError: {
                disciple: false,
                // type: false
            },
            selectedParticipants: [],
            selectedParticipantsIds: [],
            unselectedParticipants: [],
            addableParticipants: [],
            selectGroupId: '',
            newLeaderPersonId: '',
            // newDiscipleType: '',
            error: '',
            saving: false,
            locationId: '',
            editParticipant: '',
            queryString: '',
        };
    },
    computed: {
    },
    methods: {
        handleSave() {
            this.saving = true;
            this.validationError.disciple = !validateDisciple(this.selectGroupId);
            // this.validationError.type = !validateType(this.newDiscipleType);
            if (this.validationError.disciple) {
                this.saving = false;
                return;
            }
            this.selectedParticipants.forEach(this.addParticipantIds);
            DiscipleshipGroupsRepository.updateDiscipleshipGroup(
                this.selectGroupId,
                this.newLeaderPersonId,
                this.selectedParticipantsIds
            )
                .then((response) => {
                    this.saving = false;
                    this.handleClose();
                    this.$emit('save');
                    this.$emit('close');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.handleClose();
                    this.$emit('close');
                    this.$message(error.response.data.message);
                });
        },
        handleClose() {
            this.selectGroupId = '';
            this.newLeaderPersonId = '';
            this.newDiscipleType = '';
            this.validationError.disciple = false;
            this.selectedParticipants = [];
            this.selectedParticipantsIds = [];
            this.editParticipant = '';
            this.$emit('close');
        },
        fetchCurrentParticipants(groupId) {
            if (groupId === '') {
                return;
            }
            this.getAddableParticipantsList();
            DiscipleshipGroupsRepository.getCurrentParticipants(groupId)
                .then((response) => {
                    this.selectedParticipants = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getAddableParticipantsList() {
            this.selectedParticipants = [];
            DiscipleshipGroupsRepository.getAddableParticipantsList()
                .then((response) => {
                    this.addableParticipants = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getAddableLeadersList() {
            DiscipleshipGroupsRepository.getAddableLeadersList()
                .then((response) => {
                    this.leaders = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getGroups() {
            this.isReady = false;
            DiscipleshipGroupsRepository.getDiscipleshipGroups(this.locationId)
                .then((response) => {
                    this.groupsSelect = response.data.data;
                    this.isReady = true;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        queryAddableParticipants(queryString, callback) {
            this.validationError.disciple = false;
            this.unselectedParticipants = this.addableParticipants;
            if (queryString.length === 0) callback(this.unselectedParticipants);
            else {
                const results = queryString
                    ? this.unselectedParticipants.filter(
                        this.createParticipantsFilter(queryString)
                    ) : this.unselectedParticipants;
                callback(results);
            }
        },
        createParticipantsFilter(queryString) {
            return (participant) => participant.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectParticipant(participant) {
            this.selectedParticipants.push(participant);
            this.unselectedParticipants.splice(this.unselectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
            this.editParticipant = '';
        },
        handleRemoveFromSelected(participant) {
            this.unselectedParticipants.push(participant);
            this.selectedParticipants.splice(this.selectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
        },
        addParticipantIds(currentValue) {
            this.selectedParticipantsIds.push(currentValue.id);
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getAddableParticipantsList();
                this.getAddableLeadersList();
                this.getGroups();
            }
        }
    },
    created() {
    },
    mounted() {
    }

};
</script>
